module.exports = __webpack_public_path__ + "img/mobileculture5.6ff64495.png";